import { cloudAuthDesktopV2 } from "./cloudAuthDesktopV2";
import { rememberCloudBookLocalPath } from "./cloudBookPaths";

function fileBaseName(filePath: string): string {
  const parts = filePath.split(/[/\\]/);
  return parts[parts.length - 1]?.trim() || "book.sbk";
}

/** Record Save As / new local path in the cloud library (per computer). */
export async function registerDesktopLocalCopy(bookId: string, filePath: string): Promise<void> {
  const id = bookId.trim();
  const fp = filePath.trim();
  if (!id || !fp || !cloudAuthDesktopV2.isSignedIn()) return;

  const profile = await window.desktopV2Api.getMachineProfile();
  await cloudAuthDesktopV2.registerLocalCopy(id, {
    machineId: profile.machineId,
    machineName: profile.machineName,
    fileName: fileBaseName(fp),
    filePath: fp,
  });
  rememberCloudBookLocalPath(id, fp);
}

/** Resolve cloud book → local `.sbk` from API for this computer. */
export async function fetchDesktopLocalCopyPath(bookId: string): Promise<string | null> {
  const id = bookId.trim();
  if (!id || !cloudAuthDesktopV2.isSignedIn()) return null;
  try {
    const profile = await window.desktopV2Api.getMachineProfile();
    const row = await cloudAuthDesktopV2.getLocalCopy(id, profile.machineId);
    const fp = row?.filePath?.trim();
    if (!fp) return null;
    const exists = await window.desktopV2Api.pathExists(fp);
    if (!exists) return null;
    rememberCloudBookLocalPath(id, fp);
    return fp;
  } catch {
    return null;
  }
}
